import styles from "./NewsSearchBarResult.module.css";
import CategoryChip from "../CategoryChip/CategoryChip";
import { toTitleCase } from "../../data/utils";
import MindPageLink from "../MindPageLink/MindPageLink";
import DefaultPostSVG from "../SVGs/DefaultPostSVG";
import CategorySVG from "../SVGs/CategorySVG";

function NewsSearchBarResult({ result }) {
    function ResultIcon() {
        switch (result.type) {
            case "category":
                return <CategorySVG />;
            default:
                return <DefaultPostSVG />;
        }
    }

    function getResultLink() {
        switch (result.type) {
            case "category":
                return "/mind/news/category/" + result.slug;
            default:
                return "/mind/news/" + result.id;
        }
    }

    return (
        <MindPageLink href={getResultLink()} className={styles.result}>
            <div
                className={[
                    styles.icon_container,
                    "category",
                    result.type === "category" ? result.slug : "",
                ].join(" ")}
            >
                <ResultIcon />
            </div>
            <div className={styles.text}>
                <strong className={styles.title}>{result.name}</strong>
                <div className={styles.subtitle}>
                    <span className={styles.type}>
                        {toTitleCase(result.type)}
                    </span>
                    {result.type === "post" && (
                        <div className={styles.categories_container}>
                            {"•"}
                            {result.categories.map((cat) => (
                                <CategoryChip
                                    style={{ padding: "2px 8px" }}
                                    key={cat.slug}
                                    name={cat.name}
                                    slug={cat.slug}
                                    removeLink={true}
                                />
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </MindPageLink>
    );
}

export default NewsSearchBarResult;
